import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { useAuth } from 'context/auth';

function PublicRoute({ component: Component, ...rest }) {
  const { refresh } = useAuth();
  
  return (
    <Route
      {...rest}
      render={(props) =>
        refresh ? (
          <Redirect
            to={{ pathname: '/admin/home' }}
          />
          ) : (
          <Component {...props} />
        )
      }
    />
  );
}

export default PublicRoute;
